<div class="bank-transfer-confirmation p-4">
  <h2 class="mb-4">{{ 'bank_transfer_confirm_title' | translate }}</h2>

  <!-- Initializing -->
  @if (initializing()) {
    <div class="text-center py-5">
      <c-spinner color="primary"></c-spinner>
      <p class="mt-3">{{ 'bank_transfer_initializing' | translate }}</p>
    </div>
  }

  <!-- Init error -->
  @if (!initializing() && errorMessage()) {
    <c-alert color="danger" class="mb-4">
      <h4 class="alert-heading">{{ 'bank_transfer_error_title' | translate }}</h4>
      <p>{{ errorMessage() }}</p>
      <hr />
      <div class="d-flex gap-2">
        <button cButton color="danger" size="sm" (click)="retry()">{{ 'bank_transfer_retry' | translate }}</button>
        <button cButton color="secondary" size="sm" (click)="cancel()">{{ 'bank_transfer_cancel' | translate }}</button>
      </div>
    </c-alert>
  }

  <!-- Details -->
  @if (!initializing() && bank(); as b) {
    <p>{{ 'bank_transfer_intro' | translate }}</p>

    <c-card class="mb-3 shadow-sm">
      <c-card-body>
        <div class="d-flex justify-content-between mb-3">
          <strong>{{ 'bank_transfer_amount' | translate }}</strong>
          <strong class="text-primary fs-4">{{ totalPrice | currencyAmount: currency }}</strong>
        </div>

        <c-alert color="warning" class="mb-3">
          <div class="d-flex justify-content-between align-items-center">
            <strong>{{ 'bank_transfer_reference_label' | translate }}</strong>
            <strong class="fs-5">{{ b.reference }}</strong>
          </div>
          <div class="small mt-1">{{ 'bank_transfer_reference_note' | translate }}</div>
        </c-alert>

        <!-- Spesenfrei / fee-free requirement — always shown -->
        <c-alert color="info" class="mb-3">
          {{ 'bank_transfer_fee_free_note' | translate }}
        </c-alert>

        <h5 class="mb-2">{{ 'bank_transfer_beneficiary' | translate }}</h5>
        <table class="table table-sm mb-0">
          <tbody>
            @if (b.account_holder) {
              <tr><th class="w-50">{{ 'bank_transfer_account_holder' | translate }}</th><td>{{ b.account_holder }}</td></tr>
            }
            @if (b.bank_name) {
              <tr><th>{{ 'bank_transfer_bank_name' | translate }}</th><td>{{ b.bank_name }}</td></tr>
            }
            @if (b.account_number) {
              <tr><th>{{ 'bank_transfer_account_number' | translate }}</th><td>{{ b.account_number }}</td></tr>
            }
            @if (b.ach_routing) {
              <tr><th>{{ 'bank_transfer_ach_routing' | translate }}</th><td>{{ b.ach_routing }}</td></tr>
            }
            @if (b.wire_routing) {
              <tr><th>{{ 'bank_transfer_wire_routing' | translate }}</th><td>{{ b.wire_routing }}</td></tr>
            }
            @if (b.swift) {
              <tr><th>{{ 'bank_transfer_swift' | translate }}</th><td>{{ b.swift }}</td></tr>
            }
            @if (b.iban) {
              <tr><th>{{ 'bank_transfer_iban' | translate }}</th><td>{{ b.iban }}</td></tr>
            }
            @if (b.bank_address) {
              <tr><th>{{ 'bank_transfer_bank_address' | translate }}</th><td>{{ b.bank_address }}</td></tr>
            }
          </tbody>
        </table>
      </c-card-body>
    </c-card>

    <p class="text-body-secondary small">{{ 'bank_transfer_pending_note' | translate }}</p>

    <div class="d-flex gap-2">
      <button cButton color="outline-danger" (click)="cancel()">
        {{ 'bank_transfer_cancel' | translate }}
      </button>
      <button cButton color="primary" (click)="confirmDone()">
        {{ 'bank_transfer_done' | translate }}
      </button>
    </div>
  }
</div>
